import React, { useState } from "react";
import { userStore } from "../../gStore/user.store";
import { feedbackService } from "../../services/feedback.service";
import { Game } from "../../interfaces/game.interface";

type GameFeedbackInfo = {
  gameId: string;
  game?: Game;
  setShowFeedback?: any;
  feedbackLabel?: string | undefined;
  showCancel?: boolean;
  feedbackName?: string;
}

export const GameFeedback = (gameInfo: GameFeedbackInfo) => {
    const [errors, setErrors] = useState(false);

    const cancelForm = () => {
      gameInfo.setShowFeedback(false);
    }

    const handleSubmit = (e: React.SyntheticEvent) => {
      e.preventDefault();
      const formData = e.target as typeof e.target & {
        problem: { dataset: { question: string, type: string }, value: string };
        // comments: { dataset: { question: string, type: string }, value: string };
      };

      type FormResponse = {
        question: string;
        response: string | boolean | number | string[] | null;
        type: string;
      };

      
      //const formData = new FormData(e.target);

      if (formData) {
        
        let validationErrors = false;
        const formattedData: FormResponse[] = []

        if (!formData.problem.value) {
          validationErrors = true;
        } else {
          formattedData.push ({
            question: formData.problem.dataset.question,
            response: formData.problem.value || '',
            type: formData.problem.dataset.type
          });
          // formattedData.push({
          //   question: formData.comments.dataset.question,
          //   response: formData.comments.value || '',
          //   type: formData.comments.dataset.type
          // });
        }

        


        if (validationErrors) {
          setErrors(true);
        } else {
          try {
            feedbackService.sendFeedback({
              formName: `Games ${gameInfo.feedbackName || 'Issue'} Report - ${gameInfo.gameId}`,
              form: formattedData
            })
          } catch (err) {
            console.log(err)
          } finally {
            gameInfo.setShowFeedback(false);
          }
          // Handle the successful form submission, e.g., sending formData to a server
          setErrors(false); // Clear any previous errors
        }
      }
    };

    return (
        <form onSubmit={handleSubmit} id="feedbackForm" className="w-full max-w-sm ml-auto mr-auto">
          {errors && <div className="error">Please select what happened.</div>}
          <input type="hidden" name="userId" value={userStore.data.user.id} />
          <div className="md:flex md:items-center mb-6">
            <label className="block font-bold md:text-right mb-1 md:mb-0 pr-4">{gameInfo.feedbackLabel || `Please provide feedback for ${gameInfo.gameId}`}</label>
            <div className="md:w-1/3 relative">
              <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">What Happened?</label>
              <select id="problem" name="problem" data-question="What Happened?" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                <option value="">Select a Problem</option>
                <option value="dislike">Don't Like Game</option>
                <option value="crash">Crash</option>
                <option value="not-working">Not Working</option>
                <option value="other">Other</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>

          {/*<div className="md:flex md:items-center mb-6">
            <div className="md:w-1/3 relative">
              <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Any Additional Comments?</label>
              <textarea id="comments" name="comments" rows={4} cols={50} form="feedbackForm" data-question="Additional Comments" data-type="freeform" className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500 block p-2.5 w-full text-sm border" placeholder="Leave a comment..."></textarea>
            </div>
          </div>*/}
          <div className="md:flex md:items-center">
            <div className="md:w-1/3"></div>
            <div className="md:w-2/3 relative">
              <button className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded" type="submit">
                Submit Form
              </button>
              {gameInfo.showCancel &&
                <button className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded absolute right-[0px]" onClick={cancelForm}>
                  Cancel Form
                </button>
              }
            </div>
          </div>
        </form>
    )
}